import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
// import urls from "../../../../Utils/urls";
// import { useAbortController } from "../../../../hooks/useAbortController";
// import axios from "../../../../axios";
// import { reduceSum } from "../../../../Utils";

const useBorrowerDashboardTwo = () => {
  const [borrowerAccountsSummary, setBorrowerAccountsSummary] = useState(null);
  const totalAccountList = useSelector((state) => state.account.accountOptions);
  const selectedRoleObj = useSelector((state) => state.account.selectedRole);
  const [activeAccountList, setActiveAccountList] = useState([]);
  const [paidoffAccountList, setPaidoffAccountList] = useState([]);
  const [foreclosureLoansList, setForeclosureLoansList] = useState([]);

  function borrowerOptions() {
    const paidOffYes = JSON.parse(localStorage?.getItem("accessed_user"))
      .account?.filter(
        (data) =>
          data.type === selectedRoleObj.value &&
          data.paidoff_yn?.toLowerCase() === "y"
      )
      ?.map((data) => ({
        label:
          // isBorrower && data?.paidoff_yn?.toLowerCase() === "y"
          //   ? `${data?.fullname} : ${data?.account} : ${data?.paidoffdate}`
          //   :
          `${data?.fullname} - ${data?.account}`,
        value: data.recid,
        databasename: data.databasename,
        account: data.account,
      }));

    const paidOffNo = JSON.parse(localStorage?.getItem("accessed_user"))
      .account?.filter(
        (data) =>
          data.type === selectedRoleObj.value &&
          data.paidoff_yn?.toLowerCase() === "n"
      )
      ?.map((data) => ({
        label:
          // isBorrower && data?.paidoff_yn?.toLowerCase() === "y"
          //   ? `${data?.fullname} : ${data?.account} : ${data?.paidoffdate}`
          //   :
          `${data?.fullname} - ${data?.account}`,
        value: data.recid,
        databasename: data.databasename,
        displayValue: `${data?.account}`,
        prinbal: data.prinbal,
        account: data.account,
      }));

    const foreClosure = JSON.parse(localStorage?.getItem("accessed_user"))
      .account?.filter(
        (data) => data.type === selectedRoleObj.value && data.foreclosure
      )
      ?.map((data) => ({
        label:
          // isBorrower && data?.paidoff_yn?.toLowerCase() === "y"
          //   ? `${data?.fullname} : ${data?.account} : ${data?.paidoffdate}`
          //   :
          `${data?.fullname} - ${data?.account}`,
        value: data.recid,
        databasename: data.databasename,
        displayValue: `${data?.account}`,
        prinbal: data.prinbal,
        account: data.account,
      }));

    setActiveAccountList(paidOffNo);
    setPaidoffAccountList(paidOffYes);
    setForeclosureLoansList(foreClosure);

    const borrowerAccountsSummary = {
      active: paidOffNo?.length,
      paidOff: paidOffYes?.length,
      foreclosure: foreClosure?.length,
      total: paidOffYes?.length + paidOffNo?.length,
    };

    return borrowerAccountsSummary;
  }

  useEffect(() => {
    const res = borrowerOptions();
    setBorrowerAccountsSummary(res);
  }, [setBorrowerAccountsSummary]);

  return {
    borrowerAccountsSummary,
    activeAccountList,
    accountsLength: activeAccountList?.length,
    paidoffAccountList,
    totalAccountList,
    foreclosureLoansList,
  };
};

export default useBorrowerDashboardTwo;
